import AllowOrderingContainer from './AllowOrderingRadioGroup';
export default AllowOrderingContainer;
